import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import Datas from '../../data/shop/product.json';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderTwo from '../../components/HeaderTwo';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/product.js';
import { withTranslation } from 'react-i18next';

class Product extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredData: [],
            redirectToCategory: false,
        };
    }

    componentDidMount() {
        const category = this.props.match.params.category;
        this.filterProducts(category);
    }

    componentDidUpdate(prevProps) {
        const prevCategory = prevProps.match.params.category;
        const currentCategory = this.props.match.params.category;

        if (prevCategory !== currentCategory) {
            this.filterProducts(currentCategory);
        }
    }

    filterProducts(category) {
        const filteredData = Datas.filter((product) => product.category === category && product.status === "1");

        if (filteredData.length === 0) {
            console.log("No products found for this category");
            this.setState({ redirectToCategory: true });
        } else {
            this.setState({ filteredData });
        }
    }

    render() {
        const { filteredData, redirectToCategory } = this.state;
        const { t } = this.props;

        if (redirectToCategory) {
            this.props.history.push(`${process.env.PUBLIC_URL}/product-category`);
            window.location.reload();
        }

        return (
            <Styles>
                <div className="main-wrapper product-page">
                    <HeaderTwo />
                    <section className="product-area">
                        <Container>
                            <Row>
                                <Col md="12">
                                    {filteredData.length > 0 && (
                                        <nav aria-label="breadcrumb">
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item"><Link to={process.env.PUBLIC_URL + "/"}>Home</Link></li>
                                                <li className="breadcrumb-item"><Link to={`${process.env.PUBLIC_URL}/product-category`}>Products</Link></li>
                                                <li className="breadcrumb-item"><strong>{filteredData[0].category_name}</strong></li>
                                            </ol>
                                        </nav>
                                    )}
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="12" md="12" sm="7">
                                    <Row>
                                        {filteredData.length > 0 ? (
                                            filteredData.map((data, i) => (
                                                <Col lg="3" md="4" key={i}>
                                                    <div className="product-box">
                                                        <div className="product-img">
                                                            <img
                                                                src={process.env.PUBLIC_URL + `/assets/images/${data.productImg}`}
                                                                alt=""
                                                                className="img-fluid"
                                                            />
                                                            <div className="layer-box"></div>
                                                            <Link className="item_view" to={process.env.PUBLIC_URL + data.productUrl}>{t('shop.view_item')}</Link>
                                                        </div>
                                                        <div className="product-content text-center">
                                                            <div className="pro-title">
                                                                <h5>
                                                                    <Link to={process.env.PUBLIC_URL + data.productUrl}>
                                                                        {data.productTitle}
                                                                    </Link>
                                                                </h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            ))
                                        ) : (
                                            <p>{t('shop.no_products')}</p>
                                        )}
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <FooterTwo />
                </div>
            </Styles>
        );
    }
}

export default withTranslation()(Product);